<template>
    <div>
        <multiselect
            :id="id"
            :loading="isLoading"
            v-model="car"
            tag-placeholder=""
            placeholder=""
            :options="car_select"
            :close-on-select="true"
            :clear-on-select="false"
            label="title" track-by="id"
            :taggable="true"
            :selectedLabel="''"
            :placeholder="''"
            :selectLabel="''"
            :deselectLabel="''"
            :tagPlaceholder="''"
            :showNoOptions="false"
            :searchable="true"
            :disabled="disabled"
            group-values="items"
            group-label="group_name"
        >
            <template slot="option" slot-scope="props">
                <span v-if="props.option.label" class="option__title">{{props.option.label}}</span>
                <span v-if="props.option.$groupLabel" class="option__title">{{props.option.$groupLabel}}</span>
                <span v-if="props.option.title" class="option__title">{{ props.option.title }}</span>
            </template>
            <template slot="beforeList" v-if="allowed_create && $hasPermission('cars.create')">
                <li class="multiselect__element"><span class="multiselect__option"><a @click="showCreate()" class="option__title">Добавить</a></span></li>
            </template>
        </multiselect>
        <el-dialog title="Создание автомобиля" :visible.sync="form_state" width="800px" top="5vh" :append-to-body="true">
            <CarForm v-if="form_mode" :mode="form_mode" :obj="null" @created="onCreated"/>
        </el-dialog>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
import CarForm from "./CarForm";

export default {
    name: "CarSelect",
    components: {CarForm, Multiselect},
    props: ['value', 'id', 'search', 'disabled', 'allowed_create'],
    data: () => ({
        car: null,
        cars: [],

        form_state: false,
        form_mode: null,
        form_owner: null,
        isLoading: false,
    }),
    mounted() {
        let self = this;

        this.fetch();
    },
    watch: {
        car(val) {
            this.$emit('input', val ? val.id : null);
        },
        value(val) {
            let self = this;
            let i = setInterval(() => {
                if (self.isLoading === false) {
                    clearInterval(i);
                    self.car_select.forEach(group => {
                        group.items.forEach(item => {
                            if (+item.id === +val) self.car = item;
                        })
                    })
                }
            }, 1000)
        },
        search(val) {
            this.fetch();
        }
    },
    computed: {
        car_select() {
            let data = {};
            let self = this;
            this.cars.forEach(function (item) {
                if (!data[item.platform_id]) data[item.platform_id] = {group_name: PlatformHelper.get(item.platform_id).name, items: []}

                let car_info_parts = [];
                if (item.pts_year) car_info_parts.push(item.pts_year + 'г');
                if (item.modification_name) car_info_parts.push(item.modification_name);
                car_info_parts.push(item.pts_vin);

                data[item.platform_id].items.push({
                    id: item.id,
                    title: [item.brand_name, item.model_name, item.generation_name].join(' ') + ', ' + car_info_parts.join(', '),
                });
            });
            data = _.mapValues(data, function (item) {
                item.items = _.sortBy(item.items, ['title'])
                return item;
            });
            return _.values(data);
        }
    },
    methods: {
        fetch() {
            let self = this;
            this.isLoading = true;
            let params = _.clone(this.search ? this.search : {});
            params.per_page = 10000;
            params.without_joins = true;
            axios.get('/api/cars', {params})
                .then(response => {
                    self.cars = response.data.data;
                    self.isLoading = false;

                    self.car_select.forEach(group => {
                        group.items.forEach(item => {
                            if (+item.id === +self.value) self.car = item;
                        })
                    })
                });
        },
        showCreate() {
            this.form_mode = 'create';
            this.form_state = true;
        },
        onCreated(car) {
            let self = this;
            this.cars.push(car);
            this.form_state = false;
            this.car_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === car.id) self.car = item;
                })
            })
        },
    }
}
</script>

<style scoped>

</style>
